export default __webpack_public_path__ + "static/media/implants-dental.2e1c2fd1.svg";